// extracted by mini-css-extract-plugin
export default {"mCard":"GA-z","image":"HA-z","imageNoBackground":"IA-z","imageHasCategory":"JA-z","fullWidth":"KA-z"};